<template>
  <WdsStack>
    <WdsButtonGhost
      v-if="column.viewerCanManageStaffingAgencies && linkedCount > 0"
      secondary
      class="noscroll"
      :href="agenciesTabUrl"
      :data-test="`client-agencies-${rowIndex}`"
      @click="openAgenciesTab"
    >
      <WdsStack align-center gap-xs>
        {{ $tc(':count agency | :count agencies', linkedCount) }}
      </WdsStack>
    </WdsButtonGhost>
    <WdsText v-else-if="linkedCount > 0" :data-test="`client-agencies-${rowIndex}`">
      {{ $tc(':count agency | :count agencies', linkedCount) }}
    </WdsText>
    <WdsText v-else secondary :data-test="`client-agencies-${rowIndex}`">
      {{ $t('None') }}
    </WdsText>
  </WdsStack>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { WdsButtonGhost, WdsStack, WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t, $tc } from '@/app-bootstrapping/SetUpInternationalization'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'
import { ClientPageTab } from '@/components/Clients/clientPageTabs'

// Names stay in the fragment for the export describer.
const ClientRecruitersColumn = graphql(`
  fragment ClientRecruitersColumn on CompanySupplier {
    id
    viewerCanManageStaffingAgencies
    linkedStaffingAgencies(first: 100) {
      data {
        id
        recruiter {
          id
          name
        }
      }
      paginatorInfo {
        total
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof ClientRecruitersColumn>
  rowIndex?: number
}>()

const column = computed(() => useFragment(ClientRecruitersColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)

const linkedCount = computed(() => column.value.linkedStaffingAgencies.paginatorInfo.total)
const agenciesTabUrl = computed(() =>
  laravelNamedRoute(namedRoutes.frontend.clients.view, {
    companySupplier: column.value.id,
    tab: ClientPageTab.StaffingAgencies,
  }),
)

const router = useRouter()

// The client page is url-driven, so a router push opens it as the overlay; modifier clicks keep the href.
function openAgenciesTab(event: MouseEvent) {
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return

  event.preventDefault()
  router.push(agenciesTabUrl.value)
}
</script>
